import { Dateityp } from '../shared/constants';
import { Datei, Vorgang } from '../types';

export function dokumente(vorgang: Vorgang): Array<Datei> {
  return vorgang.dateien?.filter((datei) => datei.typ === Dateityp.DOKUMENT) ?? [];
}
